export default "__VITE_ASSET__DY2_Fcea__"